(function(){
"use strict";

angular.module("swapick")
.factory('NotificationStore', NotificationStore);

function NotificationStore(baseServerUrl, store){
    var svc = {}
    let deviceToken = null;

    svc.setDeviceToken = tk => {
      deviceToken = tk;
      console.info("device token set", tk);
    }
    svc.getDeviceToken = () => deviceToken;

    svc.getSavedNotifications = () => store.get('savedNotifications');
    svc.saveNotification = (data) => {
      let notifications = svc.getSavedNotifications();
      notifications = notifications || [];
      notifications.push(data);
      store.set('savedNotifications', notifications);
    }

    svc.clearNotification = (idx) => {
        let notifications = svc.getSavedNotifications();

        notifications = notifications || [];
        if(!notifications.length){
          console.warn("nothing to delete")
          return
        }
        notifications.splice(idx, 1);
        store.set('savedNotifications', notifications);
    }


    return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/notification-store.js